<script>
import { getPipeline } from '@/components/Kanban/Component.vue'

export default {
  props: {
    value: String,
    lead: String,
    reference: String,
  },
  data() {
    return {
      promises: {},
    }
  },
  computed: {
    pipeline() {
      return getPipeline(this.reference, this.$store.state.enums.KanbanSettings.pipelines)
    },
    columns() {
      const currentIndex = this.pipeline.columns.findIndex(({ id }) => id === this.value)
      return this.pipeline.columns.map((c, index, arr) => {
        const isDone = currentIndex > index

        return {
          ...c,
          status: isDone ? 'done' : currentIndex === index ? 'current' : 'undone',
          icon: isDone
            ? 'fa-pro-light:check'
            : currentIndex === index
              ? 'fa-pro-solid:flag-pennant'
              : 'fa-pro-light:circle',
        }
      })
    },
    current() {
      return this.columns.find(c => c.id === this.value)
    },
  },
  methods: {
    onClick(status) {
      const emit = () => this.$emit('input', status)
      if (!this.lead) return emit()

      const url = new URL(`/api/lead/status`, location.origin)
      url.searchParams.append('ids', this.lead)
      if (status) url.searchParams.append('status', status)

      const promise = fetch(url.toString(), { method: 'POST' }).finally(() => emit())

      this.$set(this.promises, status || 'default', promise)
    },
  },
}
</script>

<template>
  <div class="lead-statusbar">
    <div class="container">
      <strong class="mr-2">{{ $t('status') }}</strong>
      <div class="lead-statusbar__items">
        <template v-for="(column, index) in columns">
          <span v-if="index" class="divider"></span>
          <ButtonComponent
            :label="column.label"
            :icon="column.icon"
            :data-status="column.status"
            :icon-placement="column.status !== 'current' ? 'left' : 'right'"
            :style="`--c: ${column.color};`"
            :promise="promises[column.id || 'default']"
            :state-timeout="0"
            @click="() => onClick(column.id)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.lead-statusbar {
  background: linear-gradient(65deg, var(--primary-lightest), var(--primary-dark));
  border-bottom: 1px solid var(--primary-darkest);
  padding: 1rem;

  color: var(--primary-contrast);

  .container {
    display: flex;
    align-items: center;
  }

  strong {
    font-size: 1.2em;

    &:after {
      content: ':';
    }
  }

  &__items {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;

    flex-grow: 1;
  }

  .elder-button {
    border-color: var(--c);
    border-width: 2px;

    background-color: rgba(white, 0.2);
    backdrop-filter: blur(8px);
    border-radius: 99px;

    --vue-elder-button-padding-y: 0.5em;
    --vue-elder-button-padding-x: 1.25em;

    &[data-status='done'] {
      &:not(:hover) {
        opacity: 0.5;
      }
    }

    &[data-status='current'] {
      font-weight: bold;
    }

    &[data-status='undone'] {
      &:not(:hover) {
        opacity: 0.6;
      }
    }

    &:is([data-status='undone'], [data-status='current']) + .divider {
      background: repeating-linear-gradient(
        90deg,
        rgba(white, 0.4) 0,
        rgba(white, 0.4) 4px,
        transparent 4px,
        transparent 8px
      );
    }
  }

  .divider {
    width: 1.5rem;
    height: 1px;
    background-color: rgba(white, 0.4);
  }
}
</style>
